import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

export const useActiveCurrentPath = (filteredData = []) => {
    const location = useLocation();
    
    const currentPath = useMemo(() => {
        const path = location.pathname;
        
        if (!Array.isArray(filteredData) || filteredData.length === 0) {
            return null;
        }

        // Mappa i path agli indici di filteredData
        const pathMap = {
            '/ilmondodeiviniabruzzese': filteredData[0],      // indice 0
            '/sceglierebeneivini': filteredData[1],           // indice 1
            '/degustazionedeivini': filteredData[2],          // indice 2
            '/provincedellabruzzo': filteredData[3],          // indice 3
            '/tipologiainabruzzo': filteredData[4],           // indice 4
            '/vitignoinabruzzo': filteredData[5],             // indice 5
            '/enoquizabruzzo': filteredData[6],               // indice 6
            '/sagredellabruzzo': filteredData[7],             // indice 7
            "/ilmondodeiviniabruzzese/eventiEnogastronomoci": filteredData[8], // indice 8
            '/negozioonline': filteredData[9]                 // indice 9
        };

        return pathMap[path] || null;
    }, [location.pathname, filteredData]);

    return currentPath;
};


